module.exports = __webpack_public_path__ + "h5/img/passport.269e451f.png";